/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syllable counts are estimated with a phonetic heuristic and may differ slightly for unusual words.`)
};

const es_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El recuento de sílabas se calcula con una heurística fonética y puede variar ligeramente en palabras poco comunes.`)
};

const de_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Silbenzahl wird mit einer phonetischen Heuristik geschätzt und kann bei ungewöhnlichen Wörtern leicht abweichen.`)
};

const nl_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het aantal lettergrepen wordt geschat met een fonetische heuristiek en kan voor ongebruikelijke woorden licht afwijken.`)
};

const fr_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nombre de syllabes est estimé à l'aide d'une heuristique phonétique et peut légèrement varier pour des mots inhabituels.`)
};

const it_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il conteggio delle sillabe è stimato con un'euristica fonetica e può differire leggermente per parole insolite.`)
};

const pt_br2_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As contagens de sílabas são estimadas com uma heurística fonética e podem diferir ligeiramente em palavras incomuns.`)
};

const pt_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As contagens de sílabas são estimadas com uma heurística fonética e podem diferir ligeiramente em palavras invulgares.`)
};

const ja_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音節数は音声的なヒューリスティックによる推定値であり、珍しい単語では多少異なる場合があります。`)
};

const zh_syl_estimate_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音节数是通过语音启发式算法估算得出的，对于不常见的单词可能会有些许误差。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_estimate_note = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_estimate_note(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_estimate_note", locale)
	if (locale === "en") return en_syl_estimate_note(inputs)
	if (locale === "es") return es_syl_estimate_note(inputs)
	if (locale === "de") return de_syl_estimate_note(inputs)
	if (locale === "nl") return nl_syl_estimate_note(inputs)
	if (locale === "fr") return fr_syl_estimate_note(inputs)
	if (locale === "it") return it_syl_estimate_note(inputs)
	if (locale === "pt-BR") return pt_br2_syl_estimate_note(inputs)
	if (locale === "pt") return pt_syl_estimate_note(inputs)
	if (locale === "ja") return ja_syl_estimate_note(inputs)
	return zh_syl_estimate_note(inputs)
};